document
  .getElementById("whatsapp-button")
  .addEventListener("click", function (event) {
    event.stopPropagation(); // Prevent click from propagating to document
    const speechBubble = document.getElementById("speech-bubble");
    if (speechBubble.classList.contains("visible")) {
      speechBubble.classList.remove("visible");
      setTimeout(() => {
        speechBubble.style.display = "none";
      }, 500); // Matches the transition duration
    } else {
      speechBubble.style.display = "block";
      setTimeout(() => {
        speechBubble.classList.add("visible");
      }, 10); // Small delay to trigger transition
    }
  });

document.addEventListener("click", function (event) {
  const speechBubble = document.getElementById("speech-bubble");
  const whatsappButton = document.getElementById("whatsapp-button");

  if (
    !speechBubble.contains(event.target) &&
    !whatsappButton.contains(event.target)
  ) {
    if (speechBubble.classList.contains("visible")) {
      speechBubble.classList.remove("visible");
      setTimeout(() => {
        speechBubble.style.display = "none";
      }, 500); // Matches the transition duration
    }
  }
});
